import React, { useState } from "react";
import { faqData } from "../faqData/faqData";
import "../../styles/faq.css"; // Importa o CSS específico da página

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<null | number>(null);

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">Perguntas Frequentes</h2>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div key={index} className="faq-card">
              <button
                onClick={() => toggleIndex(index)}
                className="faq-question"
              >
                <span className="faq-text">{item.pergunta}</span>
                <span className="faq-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              {openIndex === index && (
                <div
                  className="faq-answer"
                  dangerouslySetInnerHTML={{ __html: item.resposta }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
